import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth-service'; // adjust path as needed
import { SiUtil } from './SiUtil';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router, private authService: AuthService,private util: SiUtil) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 404 || error.status === 403) {
                //  if (error.status === 403) {
                    console.log("*************")
                   // this.util.toastSuccess("Something Went Wrong , Server Issue")
                    // Clear session cookie (used in your AuthService)
                    this.authService.removeSession();

                    // Clear localStorage flags
                    localStorage.removeItem('isLoggedin');
                    localStorage.clear();

                    // Redirect to login
                    this.router.navigate(['/login']);
                }
                return throwError(error);
            })
        );
    }
}